import { Box } from '@mui/material'
import React from 'react'
import { Legend } from 'recharts'
import { Payload } from 'recharts/types/component/DefaultLegendContent'
import LegendItem from '../../shared/components/LegendItem'
import { PIE_CHARTS_BREAKPOINT, PIE_CHARTS_BREAKPOINT_XXS } from '../hooks/use-chart-dimensions'
import { PIE_CHART_LEGEND_VALUE_PREFIX } from 'src/Libs/qa/ids'

/*
 * This component renders the pie chart legend
 */
const PieChartLegend: React.FC<{ payload?: Payload[] }> = ({ payload }) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
      <Legend
        wrapperStyle={{ position: 'relative' }}
        payload={payload}
        align="center"
        verticalAlign="top"
        content={({ payload }) => (
          <Box
            sx={theme => ({
              display: 'flex',
              width: '100%',
              flexDirection: 'column',
              gap: 2,
              [theme.breakpoints.between(PIE_CHARTS_BREAKPOINT_XXS, PIE_CHARTS_BREAKPOINT)]: { width: 'fit-content' },
            })}
          >
            {payload?.map(entry => (
              <LegendItem
                key={`item-${entry?.id}`}
                type="donut"
                color={entry?.color || ''}
                title={entry?.dataKey?.toString() || '-'}
                value={entry?.value}
                dataQa={entry?.id ? `${PIE_CHART_LEGEND_VALUE_PREFIX}${entry.id.toString()}` : undefined}
              />
            ))}
          </Box>
        )}
      />
    </Box>
  )
}

export default PieChartLegend
